import { render, staticRenderFns } from "./EmbeddedWeb.vue?vue&type=template&id=5a864786&scoped=true"
import script from "./EmbeddedWeb.vue?vue&type=script&lang=js"
export * from "./EmbeddedWeb.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedWeb.vue?vue&type=style&index=0&id=5a864786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a864786",
  null
  
)

export default component.exports